import React, { useState, useEffect, useMemo } from "react";
import { DateRangePicker, Form } from "rsuite";
import styled from "styled-components";

import { removeNilValues } from "utils";
import FormHOC from "hoc/FilltersForm";
import { ButtonPrimary } from "components/base/BaseButton";
import CustomField from "components/Form/CustomField";
import m from "definedMessages";

const { allowedRange } = DateRangePicker;


const PostbackFilter = ({ onApplyFilters, defaultFilters, globalSettings = {}, loading, ...props }) => {
    const defaultFiltersValues = {
        ...defaultFilters,
        supplier_id: null,
        senderid: null,
        mcc_mnc: null,
        sender_sde_key: null,
        phone_sde_key: null,
        phone: null,
        reason_list: []
    };

    const allowedRanges = useMemo(() => {
        const date = new Date();
        const startDate = new Date(date.getFullYear(), date.getMonth(), 1);
        const endDate = new Date(date.getFullYear(), date.getMonth(), 1);
        const intervalMonth = globalSettings.cdr_full__interval_month || 0;
        const dateRange = [
            new Date(startDate.setMonth(startDate.getMonth() - intervalMonth)),
            new Date(endDate.setMonth(endDate.getMonth() + 12))
        ];

        return [
            `${dateRange[0].getFullYear()}-${dateRange[0].getMonth() + 1}-${dateRange[0].getDate()}`,
            `${dateRange[1].getFullYear()}-${dateRange[1].getMonth() + 1}-${dateRange[1].getDate()}`,
        ]
    }, [globalSettings]);

    const [filters, setFilters] = useState(defaultFilters);

    useEffect(() => {
        setFilters(defaultFiltersValues);
    }, []);

    const handleChange = (formValues) => {
        setFilters(formValues);
    };

    const handleApply = () => { onApplyFilters(removeNilValues(filters)); };

    return (
        <StyledForm
            layout="inline"
            onChange={handleChange}
            formDefaultValue={defaultFilters}
            formValue={filters}
        >
            <CustomField
                accepter={DateRangePicker}
                disabledDate={allowedRange(...allowedRanges)}
                cleanable={false}
                placeholder="Select Date Range"
                name="range"
                width={300}
            />

            <StyledFormGroup>
                <StyledButton
                    onClick={handleApply}
                    disabled={loading}
                >
                    Apply Filters
                </StyledButton>
            </StyledFormGroup>
        </StyledForm>
    );
};

export default FormHOC(PostbackFilter);

const StyledForm = styled(Form)`
    @media (max-width: 767px) {
        display: flex;
        flex-direction: column;
    }
`;

const StyledFormGroup = styled(Form.Group)`
    && {
        @media (max-width: 767px) {
            width: 100%;
        }
    }
`;

const StyledButton = styled(ButtonPrimary)`
    && {
        @media (max-width: 767px) {
            width: 100%;
            position: relative;
            display: flex;
            min-width: 100%;
            height: 36px;
            align-items: center;
            justify-content: center;
        }
    }
`;
